import { Home, Compass, PlusCircle, Users, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const tabs = [
  { label: 'Feed', href: '/', icon: Home },
  { label: 'Discover', href: '/discover', icon: Compass },
  { label: 'Create', href: '#create', icon: PlusCircle, isCreate: true },
  { label: 'Communities', href: '/communities', icon: Users },
  { label: 'Profile', href: '/dashboard', icon: User },
];

export default function BottomTabBar({ onCreatePost }) {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return null;

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 safe-area-bottom" data-testid="bottom-tab-bar">
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
        {tabs.map(tab => {
          const active = !tab.isCreate && location.pathname === tab.href;
          if (tab.isCreate) {
            return (
              <button key={tab.label} onClick={onCreatePost} className="flex flex-col items-center justify-center -mt-3" data-testid="tab-create">
                <div className="w-11 h-11 rounded-full bg-gradient-to-r from-[#7C3AED] to-[#2563EB] flex items-center justify-center shadow-lg shadow-purple-200">
                  <PlusCircle className="w-5 h-5 text-white" />
                </div>
              </button>
            );
          }
          return (
            <Link key={tab.label} to={tab.href} className="flex flex-col items-center justify-center gap-0.5 px-3 py-1" data-testid={`tab-${tab.label.toLowerCase()}`}>
              <tab.icon className={`w-5 h-5 ${active ? 'text-[#7C3AED]' : 'text-slate-400'}`} />
              <span className={`text-[10px] font-medium ${active ? 'text-[#7C3AED]' : 'text-slate-400'}`}>{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
